export default __webpack_public_path__ + "static/media/blue_bg.f50ab2a0.png";